import gql from 'graphql-tag';

import {
  EventItemFeaturesDetails,
  PurchasedEventItemFeaturesDetails,
} from '../fragments/events';

export const EventItems = gql`
  query eventItems {
    eventItems(platform: WEB, include_weddings_free_plan: true) {
      id
      album_subtype
      album_type
      app_store_id
      price {
        value
        currency
      }
      video_guestbook_enabled
      free_waldograms_count
      plan
      name
      ...EventItemFeaturesDetails
    }
  }
  ${EventItemFeaturesDetails}
`;

export const MeForPurchasedEvents = gql`
  query meForPurchasedEvents(
    $album_type: AlbumTypesType
    $album_subtype: AlbumSubtypesType
    $unassigned_only: Boolean = true
    $assigned_only: Boolean = false
    $purchased_event_id: RecordID
    $album_folder_id: RecordID
    $limit: Int = 999
    $offset: Int = 0
  ) {
    me {
      id
      roles
      purchased_events(
        album_type: $album_type
        album_subtype: $album_subtype
        unassigned_only: $unassigned_only
        assigned_only: $assigned_only
        purchased_event_id: $purchased_event_id
        album_folder_id: $album_folder_id
        slice: { limit: $limit, offset: $offset }
      ) {
        records {
          id
          album_type
          album_subtype
          album_folder {
            id
            purchased_event {
              id
              ...PurchasedEventItemFeaturesDetails
            }
          }
          config_url
          free_waldograms_count
          video_guestbook_enabled
          plan
          name
          ...PurchasedEventItemFeaturesDetails
        }
        total
      }
    }
  }
  ${PurchasedEventItemFeaturesDetails}
`;
